import { c as _c } from "react/compiler-runtime";
import { IcoBook16 } from '@onefootprint/icons';
import { LinkButton } from '@onefootprint/ui';
import { type ComponentProps, type ReactNode, useState } from 'react';
import { Trans } from 'react-i18next';
import CelInstructionsDialog from '../cel-instructions-dialog';
type CelNodeFormSubtitleProps = Pick<ComponentProps<typeof Trans>, 'i18nKey'>;
export const CelNodeFormSubtitle = t0 => {
  const $ = _c(3);
  const {
    i18nKey
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      kbd: <kbd className="text-snippet-2" />
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== i18nKey) {
    t2 = <Trans i18nKey={i18nKey} components={t1} parent="p" className="text-caption-2 text-tertiary" ns="playbook-builder" />;
    $[1] = i18nKey;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export type CelNodeFormInstructionsProps = {
  subtitle: ReactNode;
  celSubtitle: string;
  instructionsLabel: string;
};
export const CelNodeFormInstructions = t0 => {
  const $ = _c(17);
  const {
    subtitle,
    celSubtitle,
    instructionsLabel
  } = t0;
  const [showCelInstructions, setShowCelInstructions] = useState(false);
  let t1;
  if ($[0] !== celSubtitle) {
    t1 = <p className="text-caption-2 text-tertiary mt-1">{celSubtitle}</p>;
    $[0] = celSubtitle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subtitle || $[3] !== t1) {
    t2 = <div className="flex flex-col">{subtitle}{t1}</div>;
    $[2] = subtitle;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setShowCelInstructions(true);
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== instructionsLabel) {
    t4 = <LinkButton type="button" onClick={t3} iconComponent={IcoBook16} iconPosition="left" variant="label-3" className="flex-shrink-0">{instructionsLabel}</LinkButton>;
    $[6] = instructionsLabel;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="flex justify-between items-start gap-2">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setShowCelInstructions(false);
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== showCelInstructions) {
    t7 = <CelInstructionsDialog open={showCelInstructions} onClose={t6} />;
    $[12] = showCelInstructions;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <>{t5}{t7}</>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};